import jQuery from 'jquery';

const $ = jQuery;

require("./modules/useragent");

require("./modules/smoothscroll");

require("./modules/site");

require("./modules/menu");

require("./modules/slider");

require("./modules/drop");

/*
require("./modules/tab");

require("./modules/loading");

require("./modules/map");

*/


